import { Injectable } from '@angular/core';
import { EarnPointsModel } from './models/earn-points.model';
import { EarnPointsStore } from './earn-points.store';
import { ApiService } from '../../shared/services/core/api.service';
import { LoggingService } from '../../shared/services/core/logging.service';
import { tap } from 'rxjs/operators';
import { cacheable } from '@datorama/akita';

@Injectable({ providedIn: 'root' })
export class EarnPointsService {
  constructor(private earnPointsStore: EarnPointsStore, private api: ApiService, private logService: LoggingService) {}

  /** Fetch all earn points and put them in the store.
   *
   * @param populationId population variant added onto call
   * @param lcid language variant to be displayed
   */

  fetchEarnPoints(populationId: number, lcid: number, clubId: number) {
    this.logService.debug(`Fetching Earn Points`);

    const request$ = this.api
      .get<EarnPointsModel>(`content/EarnPoints?clubId=${clubId}&lcid=${lcid}&populationId=${populationId}`)
      .pipe(
        tap((earnPoints) => {
          this.earnPointsStore.set(earnPoints);
        })
      );

    return cacheable(this.earnPointsStore, request$);
  }
}
